export default {"src":"/_next/static/media/MORF.9b899e7f.svg","height":18,"width":18};